import { render, staticRenderFns } from "./SubstrateEditor.vue?vue&type=template&id=25003a30&"
import script from "./SubstrateEditor.js?vue&type=script&lang=js&"
export * from "./SubstrateEditor.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports